module.exports = __webpack_public_path__ + "img/logo_news.7b451a12.jpg";